<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["virtual_garage"] }}
        </p>
      </div>
      <p class="content_title" v-if="cars.length > 0">
        {{ this.$store.getters.TRANSLATIONS["your_cars"] }}
      </p>
      <p class="content_title" v-if="cars && cars.length <= 0">
        {{ this.$store.getters.TRANSLATIONS["no_cars_yet"] }}
      </p>
      <div
        class="car"
        v-for="item in cars"
        :key="item.id"
        v-on:click="next(item)"
      >
        <img
          :src="carIcon"
          class="car_icon"
          :style="getStyleForColor(item.color)"
        />
        <button class="button car_button">
          {{ item.make || "" }} {{ item.model || "" }} {{ item.color || "" }}
        </button>
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="addCar()" class="button add_car_button">
        {{ this.$store.getters.TRANSLATIONS["add_new_car"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created() {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
      return;
    }
    const timeout = setTimeout(() => {
      this.loading = true;
    }, 0);
    this.$http
      .get(`${process.env.SERVER_URL}/D7C6E2054AD44EADB6F95078ED4447F8`, {
        headers: {
          "x-access-token": this.$storage.get("parkendaToken")
        }
      })
      .then((response) => {
        console.log("Get user cars response:");
        console.log(response);
        if (response.data) {
          this.cars = response.data;
        } else {
          console.log("Can't get cars list from server");
        }
      })
      //   .then(() => {
      //     return this.$http
      //       .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
      //         headers: {
      //           "x-access-token": this.$storage.get("parkendaToken")
      //         }
      //       })
      //       .then(response => {
      //         console.log("Get current user response:");
      //         console.log(response);
      //         if (response.data) {
      //           this.$store.dispatch("SAVE_USER", response.data);
      //           this.defaultCardId = response.data.defaultCardId;
      //         }
      //       });
      //   })
      .catch((error) => {
        let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
        this.$modal.show("dialog", {
          text,
          buttons: [
            {
              title: "OK",
              handler: () => {
                this.$storage.remove("parkendaToken");
                this.$router.push("/login");
              }
            }
          ]
        });
      })
      .finally(() => {
        clearTimeout(timeout);
        this.loading = false;
      });
  },
  data() {
    return {
      loading: true,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      carIcon: require("@/assets/new_design/car_icon.png"),
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      cars: [],
      next: (item) => {
        let User = this.$store.getters.USER;
        User.selectedCar = item;
        this.$store.dispatch("SAVE_USER", User);
        this.$router.push("/carEdit");
      },
      addCar: () => {
        this.$router.push("/carAdd");
      },
      back: () => {
        this.$router.go(-1);
      },
      getStyleForColor: (color) => {
        return { filter: `opacity(.5) drop-shadow(0 0 0 ${color})` };
      },
      icon: require("@/assets/icon_back.png"),
      nextIcon: require("@/assets/nextArrowIos.jpg")
    };
  }
};
</script>

<style src="../../styles/main.css"></style>
<style scoped>
.add_car_button {
  margin: 7vh auto 5vh;
  background-color: white;
  color: #fbae31;
}
.car_button {
  height: 4vh;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Cars/List.vue